import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableParawargrtnawakan from "./ScroollTableParawargrtnawakan";
import FooterOfParawargrtnawakan from "./FooterOfParawargrtnawakan";
import FillDetailParawargrtnawakan from "./FillDetailParawargrtnawakan";
const AllParawargrtnawakan = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailParawargrtnawakan />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableParawargrtnawakan />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 col-12">
            <FooterOfParawargrtnawakan />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllParawargrtnawakan;
